import { WidgetType } from '../content/contentBuilder/widgets/widgetType';
import { FillInQuestionHelper } from '../content/contentBuilder/widgets/FillInQuestionWidget';
export const FillInQuestionWidgetConverter = {
    convertDomainModel: (serverData) => {
        var _a, _b, _c, _d, _e, _f, _g;
        const properties = {
            isRequired: (_a = serverData.properties.isRequired) !== null && _a !== void 0 ? _a : false,
            displayDelayInSeconds: (_b = serverData.properties.displayDelayInSeconds) !== null && _b !== void 0 ? _b : 0,
            areAnswersCaseSensitive: (_c = serverData.properties.areAnswersCaseSensitive) !== null && _c !== void 0 ? _c : false,
            revealAnswers: (_d = serverData.properties.revealAnswers) !== null && _d !== void 0 ? _d : true,
            repeatUntilCorrect: (_e = serverData.properties.repeatUntilCorrect) !== null && _e !== void 0 ? _e : true,
        };
        const feedback = {
            feedbackCorrect: (_f = serverData.data.feedbackCorrect) !== null && _f !== void 0 ? _f : null,
            feedbackIncorrect: (_g = serverData.data.feedbackIncorrect) !== null && _g !== void 0 ? _g : null,
        };
        const titleAssetId = serverData.data.assetId;
        return FillInQuestionHelper.create(serverData.id, serverData.trackingIdentifier, serverData.data.questionText, serverData.data.validAnswers, properties, feedback, titleAssetId);
    },
    convertToServerModel: (widget) => {
        return {
            type: WidgetType.fillInQuestion,
            id: widget._id,
            trackingIdentifier: widget.trackingIdentifier,
            data: {
                questionText: widget.value.data.questionText,
                validAnswers: widget.value.data.validAnswers,
                assetId: widget.value.data.titleAssetId,
                feedbackCorrect: widget.value.data.feedbackCorrect,
                feedbackIncorrect: widget.value.data.feedbackIncorrect,
            },
            properties: {
                isRequired: widget.value.properties.isRequired,
                displayDelayInSeconds: widget.value.properties.displayDelayInSeconds,
                areAnswersCaseSensitive: widget.value.properties.areAnswersCaseSensitive,
                revealAnswers: widget.value.properties.revealAnswers,
                repeatUntilCorrect: widget.value.properties.repeatUntilCorrect,
            },
        };
    },
};
